import AsyncPage from 'pages/AsyncPage'
import { loadDraft } from 'actions/drafts'

import universal from 'react-universal-component'
const component = universal(props => import('./TagPostPage'))

class AsyncTagPostPage extends AsyncPage {
  constructor() {
    super({
      title: 'compose.tag.page_title',
      pageComponent: component
    })
  }
  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    const {
      location: { payload: { postType, postId } },
      draft: { value: post, error, upsertError: publishingError, loading }
    } = getState()
    if (post || error || publishingError) {
      // this is the most likely case - user has moved on from the
      // composer by clicking "next", so the post is already loaded
      // in the `drafts` section of our application state or something
      // blew up when trying to publish
    } else {
      // user refreshed, or perhaps had a bookmark (!?) ...
      // load existing post from the API
      const draft = await loadDraft({ _id: postId, type: postType })(
        dispatch,
        getState,
        opts
      )
    }
  }
}

export default new AsyncTagPostPage()
